import type { ShortsAudioControl } from '@/lib/shorts-audio-control'

const UNLOCKED_KEY = 'haber-shorts-audio-unlocked-v1'

const controls = new Set<ShortsAudioControl>()

export function loadShortsAudioUnlocked(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.sessionStorage.getItem(UNLOCKED_KEY) === '1'
  } catch {
    return false
  }
}

export function saveShortsAudioUnlocked(unlocked: boolean) {
  if (typeof window === 'undefined') return
  try {
    if (unlocked) window.sessionStorage.setItem(UNLOCKED_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function registerShortsAudioControl(control: ShortsAudioControl) {
  controls.add(control)
  return () => {
    controls.delete(control)
  }
}

/** Run inside a user gesture so every mounted Shorts player can keep audio. */
export function primeAllShortsAudio(muted: boolean, volume: number) {
  controls.forEach((control) => {
    try {
      control.applyUserAudio(muted, volume)
    } catch {
      /* player may be disposing */
    }
  })
}
